import { Table, TableContainer } from '@material-ui/core';
import { AgentInLenderContext, Lender, MerchantStructure } from '@nemuru-eng/js-api-client';

import { TableBodyContent } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/components/TableBodyContent';
import { getTableColumns } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/constants/getTableColumns';
import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
import withTableBodyWrapper from '@/components/modules/AgentDetail/ProvidersDetails/shared/HOC/withTableBodyWrapper';
import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { PendingDataType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

interface AgentInLenderContextTableProps {
  agentId: string;
  channelId: string;
  lenders: Lender[];
  merchantStructure: MerchantStructure;
  credentialsType: CredentialsType;
  hideColumnsForDeleteMode?: boolean;
  agentsInLenderContextCredentials?: AgentInLenderContext[];
}

export const AgentInLenderContextTable = ({
  agentId,
  channelId,
  lenders,
  merchantStructure,
  credentialsType,
  agentsInLenderContextCredentials,
  hideColumnsForDeleteMode,
}: AgentInLenderContextTableProps) => {
  const tableElementId = 'financial-entities-table-container';
  const { classes, stickyCellStyle, isScrollable } = useDefaultTable({
    tableElementId,
  });
  const { isMobile } = useScreen();
  const columns = getTableColumns({ isMobile, hideColumnsForDeleteMode });
  const TableBodyContentElement = withTableBodyWrapper(TableBodyContent);
  let sortedAgentsInLenderContext: AgentInLenderContext[] | undefined;

  if (agentsInLenderContextCredentials) {
    sortedAgentsInLenderContext = agentsInLenderContextCredentials.sort((a, b) =>
      `${a.lenderId}-${a.id}` > `${b.lenderId}-${b.id}` ? 1 : -1,
    );
  }

  if (!sortedAgentsInLenderContext) return <PendingDataWarning type={PendingDataType.CREDENTIALS} />;
  return (
    <>
      <TableContainer id={tableElementId}>
        <Table>
          <CustomHeader columns={columns} tableProps={{ classes, stickyCellStyle }} />
          <TableBodyContentElement
            agentId={agentId}
            channelId={channelId}
            agentInContextArray={sortedAgentsInLenderContext}
            lenders={lenders}
            merchantStructure={merchantStructure}
            tableProps={{ classes, stickyCellStyle }}
            credentialsType={credentialsType}
            hideColumnsForDeleteMode={hideColumnsForDeleteMode}
          />
        </Table>
      </TableContainer>
      {isScrollable && <SliderWarning />}
    </>
  );
};
